<div class="min-h-screen bg-slate-50 text-slate-800">
  <app-course-sidebar
    [variant]="'course-editor'"
    [isOpen]="isSidebarOpen"
    [course]="course"
    (closeSidebar)="onCloseSidebar()"
    (lessonClick)="onLessonClick($event)"
    (moduleClick)="onModuleClick($event)"
    (questionClick)="onQuestionClick($event)"
    (addModule)="onAddModule()"
    (addLesson)="onAddLesson($event)"
    (editLesson)="onEditLesson($event)"
    (deleteLesson)="onDeleteLesson($event)"
  />

  @if (isSidebarOpen) {
  <div
    class="fixed inset-0 z-50 bg-slate-900/40 backdrop-blur-sm transition-opacity lg:hidden"
    (click)="onToggleSidebar()"
    aria-hidden="true"
  ></div>
  }

  <div
    class="relative flex min-h-screen flex-col transition-all"
    [ngClass]="{
      'lg:ms-[300px]': isSidebarOpen,
      'lg:ms-0': !isSidebarOpen
    }"
  >
    <app-course-header
      [applicationTitle]="'Editor de cursos'"
      [sidebarCollapsed]="!isSidebarOpen"
      (toggleSidebar)="onToggleSidebar()"
    />

    <div class="flex-1 overflow-hidden pt-[48px]">
      <div class="grid grid-cols-1 lg:grid-cols-12 h-[calc(100vh-48px)]">
        <!-- Área de Conteúdo -->
        <div
          class="col-span-1 lg:col-span-9 relative flex flex-col"
          style="height: calc(100vh - 48px)"
        >
          <!-- Barra de Ações -->
          <app-action-bar
            [currentModule]="currentModule"
            [isPreviewMode]="isPreviewMode()"
            [isCurrentModuleEmpty]="isCurrentModuleEmpty"
            (togglePreview)="onTogglePreview()"
            (editModule)="onEditModule($event)"
            (deleteModule)="onDeleteModule($event)"
            (addLesson)="onAddLesson($event)"
            (addQuestion)="onAddQuestion($event)"
          />

          <div class="flex-1 min-h-0 overflow-y-auto">
            @if (currentModule?.contentType === 'evaluations') {
            <div class="w-full" #contentContainer></div>
            } @else if (currentLesson) {
            <div class="w-full" #contentContainer></div>
            } @else if (currentModule && isCurrentModuleEmpty) {
            <div class="flex items-center justify-center h-full">
              <div class="text-center">
                <i
                  class="bi bi-folder-x text-6xl text-gray-400 dark:text-neutral-500 mb-4 block"
                ></i>
                <h3
                  class="text-xl font-semibold text-gray-900 dark:text-white mb-2"
                >
                  Módulo vazio
                </h3>
                <p class="text-sm text-gray-600 dark:text-neutral-400">
                  @if (currentModule.contentType === 'lessons') { Este módulo
                  ainda não possui conteúdo. Adicione lições{{ isPreviewMode() ?
                  ' para visualizar o preview' : ' para começar a editar' }}. }
                  @else if (currentModule.contentType === 'evaluations') { Este
                  módulo ainda não possui conteúdo. Adicione questões{{
                  isPreviewMode() ? ' para visualizar o preview' : ' para
                  começar a editar' }}. }
                </p>
              </div>
            </div>
            } @else {
            <div class="flex items-center justify-center h-full">
              <div class="text-center">
                <i
                  class="bi bi-file-earmark-plus text-6xl text-gray-400 dark:text-neutral-500 mb-4 block"
                ></i>
                <h3
                  class="text-xl font-semibold text-gray-900 dark:text-white mb-2"
                >
                  Nenhuma lição selecionada
                </h3>
                <p class="text-sm text-gray-600 dark:text-neutral-400">
                  Selecione uma lição na sidebar ou crie uma nova para começar a
                  editar
                </p>
              </div>
            </div>
            }
          </div>
        </div>

        <!-- Barra Lateral Direita -->
        <div class="col-span-1 lg:col-span-3 h-full min-h-0 flex flex-col">
          <div class="flex-1 min-h-0 overflow-y-auto">
            <app-course-info
              [variant]="'course-editor'"
              (courseUpdated)="updateCourseData()"
            />
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Modais -->
  @if (showModuleForm()) {
  <div
    class="fixed inset-0 z-[70] flex items-center justify-center p-4"
    style="
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0, 0, 0, 0.5);
      z-index: 70;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 1rem;
    "
    (click)="onModuleFormCancel()"
    (keyup.escape)="onModuleFormCancel()"
    tabindex="0"
    role="dialog"
    aria-modal="true"
    aria-labelledby="module-form-title"
  >
    <div
      class="bg-white rounded border border-gray-200 shadow-sm max-w-md w-full"
      (click)="$event.stopPropagation()"
      (keydown.escape)="onModuleFormCancel()"
      tabindex="0"
    >
      <app-module-form
        [moduleId]="editingModuleId()"
        [moduleName]="editingModuleName()"
        [moduleDescription]="editingModuleDescription()"
        [moduleContentType]="editingModuleContentType()"
        (save)="onModuleFormSave($event)"
        (cancelClick)="onModuleFormCancel()"
      >
      </app-module-form>
    </div>
  </div>
  } @if (showLessonForm()) {
  <div
    class="fixed inset-0 z-[70] flex items-center justify-center p-4"
    style="
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0, 0, 0, 0.5);
      z-index: 70;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 1rem;
    "
    (click)="onLessonFormCancel()"
    (keyup.escape)="onLessonFormCancel()"
    tabindex="0"
    role="dialog"
    aria-modal="true"
    aria-labelledby="lesson-form-title"
  >
    <div
      class="bg-white rounded border border-gray-200 shadow-sm max-w-md w-full"
      (click)="$event.stopPropagation()"
      (keydown.escape)="onLessonFormCancel()"
      tabindex="0"
    >
      <app-lesson-form
        (save)="onLessonFormSave($event)"
        (canceled)="onLessonFormCancel()"
      >
      </app-lesson-form>
    </div>
  </div>
  } @if (showQuestionForm()) {
  <div
    class="fixed inset-0 z-[70] flex items-center justify-center p-4"
    style="
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0, 0, 0, 0.5);
      z-index: 70;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 1rem;
    "
    (click)="onQuestionFormCancel()"
    (keyup.escape)="onQuestionFormCancel()"
    tabindex="0"
    role="dialog"
    aria-modal="true"
    aria-labelledby="question-form-title"
  >
    <div
      class="bg-white rounded border border-gray-200 shadow-sm max-w-2xl w-full max-h-[90vh] overflow-y-auto"
      (click)="$event.stopPropagation()"
      (keydown.escape)="onQuestionFormCancel()"
      tabindex="0"
    >
      <app-question-form
        [question]="getEditingQuestion()"
        [isEditMode]="!!editingQuestionId()"
        (save)="onQuestionFormSave($event)"
        (canceled)="onQuestionFormCancel()"
      >
      </app-question-form>
    </div>
  </div>
  }
</div>
